<template>
  <div class="mobile_container">
    <div class="mobile_header">
      <img src="../../assets/img/logo.png" alt="logo">
      <span @click="dialogVisible = true">
        下载APP
      </span>
    </div>
    <el-dialog
      class="mobile_header_code"
      title="下载App"
      :visible.sync="dialogVisible"
      >
      <img src="../../assets/img/appCode.jpg" alt="">
      <span>识别图中的二维码</span>
    </el-dialog>
    <div class="mobile_down_btn">
      下载App
    </div>
  </div>
</template>

<script>
export default ({
  data () {
    return {
      dialogVisible: false
    }
  },
  created () {
    document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px'
  }
})
</script>

<style>
</style>
